var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobCardRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-16 0 480 480",
    width: "480pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m344 56v352h64c17.671875 0 32-14.328125 32-32v-320c0-26.507812-21.492188-48-48-48s-48 21.492188-48 48zm0 0",
    fill: "#EA2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56 8c-26.507812 0-48 21.492188-48 48v384c0 17.671875 14.328125 32 32 32h272c17.671875 0 32-14.328125 32-32v-384c0-26.507812 21.492188-48 48-48zm0 0",
    fill: "#FE7E7E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3d42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392 0h-336c-30.914062.0351562-55.9648438 25.085938-56 56v384c.0273438 22.082031 17.917969 39.972656 40 40h272c22.082031-.027344 39.972656-17.917969 40-40v-24h56c22.082031-.027344 39.972656-17.917969 40-40v-320c-.035156-30.914062-25.085938-55.9648438-56-56zm-56 440c0 13.253906-10.746094 24-24 24h-272c-13.253906 0-24-10.746094-24-24v-384c.027344-22.082031 17.917969-39.972656 40-40h296.886719c-10.800781 10.503906-16.890625 24.933594-16.886719 40zm96-64c0 13.253906-10.746094 24-24 24h-56v-344c0-22.089844 17.910156-40 40-40s40 17.910156 40 40zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 144h16c13.253906 0 24-10.746094 24-24v-72h-16v72c0 4.417969-3.582031 8-8 8h-16c-4.417969 0-8-3.582031-8-8h-16c0 13.253906 10.746094 24 24 24zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 144h16c13.253906 0 24-10.746094 24-24v-48c0-13.253906-10.746094-24-24-24h-16c-13.253906 0-24 10.746094-24 24v48c0 13.253906 10.746094 24 24 24zm-8-72c0-4.417969 3.582031-8 8-8h16c4.417969 0 8 3.582031 8 8v48c0 4.417969-3.582031 8-8 8h-16c-4.417969 0-8-3.582031-8-8zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 48h-32c-4.417969 0-8 3.582031-8 8v80c0 4.417969 3.582031 8 8 8h32c13.253906 0 24-10.746094 24-24v-8c-.019531-5.921875-2.246094-11.625-6.238281-16 3.992187-4.375 6.21875-10.078125 6.238281-16v-8c0-13.253906-10.746094-24-24-24zm-24 16h24c4.417969 0 8 3.582031 8 8v8c0 4.417969-3.582031 8-8 8h-24zm32 56c0 4.417969-3.582031 8-8 8h-24v-24h24c4.417969 0 8 3.582031 8 8zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 184h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 184h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 184h144v16h-144zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 232h96v16h-96zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 232h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 232h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 280h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 280h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 280h16v16h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 280h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 336h96v16h-96zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 336h48v16h-48zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 336h48v16h-48zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 392h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 392h80v16h-80zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 392h80v16h-80zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCardRed);
export default __webpack_public_path__ + "static/media/job-card-red.38d7f149690b84cb046d8068708a067f.svg";
export { ForwardRef as ReactComponent };